export default {
  link_expired: "Срок действия ссылки истек",
  accountVerified: "Аккаунт успешно активирован! Войдите, чтобы начать путешествие.",
  gmi: "Войти",
  Sign_In :"Войти",
  Creating_Account: "Создание учетной записи",
};
